import { render, staticRenderFns } from "./IconStatsEmpty.vue?vue&type=template&id=547fa0b4&"
import script from "./IconStatsEmpty.vue?vue&type=script&lang=js&"
export * from "./IconStatsEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('547fa0b4')) {
      api.createRecord('547fa0b4', component.options)
    } else {
      api.reload('547fa0b4', component.options)
    }
    module.hot.accept("./IconStatsEmpty.vue?vue&type=template&id=547fa0b4&", function () {
      api.rerender('547fa0b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconStatsEmpty.vue"
export default component.exports